export default __webpack_public_path__ + "static/media/03.dd6acf3f.jpg";